import { ReactElement } from 'react';
import { useWindowWidth } from '@react-hook/window-size';
import {  useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

// Web Components
import { DateBarView } from './date-bar.styles';

// Constant
import { constant } from '../../constants/contant';

// Utils
import { getDaysCountByWidth } from '../../utils/common.utils';

// Selectors
import { capitalizedLang } from '../../selectors/common.selector';

// Types
import { QueryFilters, Filters as Filter } from '../../types/query-filters';

const DateBar = ({ onDateBarChange, mode }: any): ReactElement => {
	const windowWidth = useWindowWidth();
	const lang = useSelector((state: any) => capitalizedLang()(state));
	const dir = useSelector((state: any) => state.common.dir);
	const facets = useSelector((state: any) => state.facet.data);
	const eventDates = useSelector((state: any) => state.event.dates);

	const location = useLocation();
	const history = useHistory();

	const onDateSelect = (event: any) => {
		const startDate =
			new Date(
				event.detail.year,
				event.detail.month,
				event.detail.date,
				0,
				0,
				0,
			).getTime() / 1000;

		const endDate =
			new Date(
				event.detail.year,
				event.detail.month,
				event.detail.date,
				23,
				59,
				59,
			).getTime() / 1000;

		
		let query: QueryFilters = new QueryFilters(location.search, facets);
		let newQuery: Filter = { ...query.parsedQuery, startDate, endDate };
		onDateBarChange({
			type: 'dataBar',
			startDate,
			endDate,
		});
		navigate(query, newQuery);
	};

	const navigate = (query: QueryFilters, newQuery: Filter) => {
		query.updateFiltersFromObject(newQuery);
		history.push(`${location?.pathname}?${query.filters}`);
	};

	return (
		<DateBarView
		    mode={mode}
			language={dir}
			eventDates={JSON.stringify(eventDates)}
			days={getDaysCountByWidth(windowWidth)}
			daysLabel={constant[lang].VARIABLES.DAYS_IN_WEEK}
			monthsLabel={constant[lang].VARIABLES.CALENDAR_MONTHS}
			onBiuDateClick={onDateSelect}
		/>
	);
};

export default DateBar;
